import React from 'react';
import { AppButton, Box, Inscription, Preloader } from '@common-fe/common-fe';

interface Props {
  testId?: string;
  isSubmitDisabled?: boolean;
  onSubmit: () => void;
  isLoading?: boolean;
  errorText?: string;
}

const Footer: React.FC<Props> = ({ testId, isSubmitDisabled, onSubmit, isLoading, errorText }) => {
  return (
    <Box margin={{ top: 'auto' }} pad="spacing48" background="module">
      <Box align="center">
        {errorText && (
          <Inscription data-testId={`${testId}_footer_error-text`} margin={{ bottom: 'spacing24' }} color="danger">
            {errorText}
          </Inscription>
        )}
        <AppButton
          width="320px"
          size="L"
          onClick={onSubmit}
          disabled={isSubmitDisabled}
          testId={`${testId}-submit`}
        >
          {isLoading ? <Preloader /> : 'Submit'}
        </AppButton>
      </Box>
    </Box>
  );
};

export default Footer;
